import { escapeHtml } from "./escapeHtml";
import type { PrintLayout } from "./printLayout";

export function buildFooterHtml(layout: PrintLayout, alt: string): string {
  const hasText = Boolean(layout.footerText?.trim());
  if (!hasText) return "";
  const align = layout.footerAlign;
  const itemsAlign = align === "center" ? "center" : align === "right" ? "flex-end" : "flex-start";
  return `<footer class="doc-footer" data-zone="footer" aria-label="${escapeHtml(alt)}" style="text-align:${align};align-items:${itemsAlign}">
    <div style="white-space:pre-line;color:${layout.footerTextColor}">${escapeHtml(layout.footerText!.trim())}</div>
  </footer>`;
}
